function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Failed to load image."
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Alert, Spin } from "antd";
import { t } from "ttag";
export var URL_PROTOCOL_REGEXP = /^https?:\/\//;
var Loader = function(param) {
    var src = param.src, onLoad = param.onLoad;
    if (typeof src === "undefined" || !URL_PROTOCOL_REGEXP.test(src)) {
        return /*#__PURE__*/ React.createElement(Alert, {
            message: t(_templateObject()),
            type: "error",
            showIcon: true
        });
    }
    var img = new Image();
    img.src = src;
    img.onload = onLoad;
    return /*#__PURE__*/ React.createElement(Spin, {
        style: {
            display: "flex",
            justifyContent: "center"
        },
        indicator: /*#__PURE__*/ React.createElement(Loading3QuartersOutlined, {
            style: {
                fontSize: "24px",
                color: "#575757"
            },
            spin: true
        })
    });
};
export default Loader;
